import { PrivateDocumentItemFormModel } from 'models/documents.model';

export const getProduct = (items: PrivateDocumentItemFormModel[]) =>
  items.length > 2
    ? `${items[0].name}, ${items[1].name}...`
    : items.map((item) => item.name).join(', ');

export const getAmount = (items: PrivateDocumentItemFormModel[]) =>
  items.length > 2
    ? `${items[0].numberOfUnits}, ${items[1].numberOfUnits}...`
    : items.map((item) => item.numberOfUnits).join(', ');

export const calculateTotalValue = (items: PrivateDocumentItemFormModel[]) =>
  items.reduce((totalPriceSum, item) => (totalPriceSum += item.totalPrice ?? 0), 0);

export const calculatePaymentDueDate = () => {
  let paymentDueDate = new Date();
  paymentDueDate.setDate(paymentDueDate.getDate() + 30);
  return paymentDueDate;
};

export const defaultDocumentInfoModelProps = {
  versionName: 'v1',
  validSince: '2020-11-10T20:10:10',
  validUntil: '2030-11-10T20:10:10',
  retainUntil: '2030-11-10T20:10:10',
  publicationMode: 'NEW',
  identity: {
    id: 'identity-c16697a9-cdb1-4a86-b59c-97b8511bdf4e',
  },
};
